<mat-card>
    <mat-card-content class="p-16">

        <mat-stepper [orientation]="orientation" [linear]="false" [selectedIndex]="currentIndex()" class="hide-content complete-color-success no-click active-m">
            <mat-step *ngFor="let s of steps; let i = index" 
                [completed]="getCompleted(i)" 
                [editable]="false" 
                >
                <ng-template matStepLabel><span class="uppercase" [ngClass]="{'active': isActiveStep(i) }">{{ s.name}}</span></ng-template>
            </mat-step>
        </mat-stepper>

    </mat-card-content>
</mat-card>
